import router from "src/routes/routes";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);

export const verificationService = {
  getShifts: async (params) => {
    return api.getCall("/api/verification/shifts", params);
  },

  getSummary: async (params) => {
    return api.getCall("/api/verification/summary", params);
  },

  downloadCsv: async (params) => {
    return api.getBlobCall("/api/verification/csv", params);
  },
};
